import React from 'react'
import Modal from './Modal'
import CarsTable from '../tabels/CarsTable'

function CustomerCarsModal({ customer, setShowModal }) {
  return (
    <Modal isLargeModal={true}>
      <div>
        {/*header*/}
        <div className="flex items-center justify-between mb-8">
          <h3 className="text-xl md:text-2xl font-semibold text-center dark:text-slate-200">
            خودروهای {customer?.full_name}
          </h3>
          <i
            className={
              'icon-close-circle bg-light-gray dark:bg-slate-600 dark:text-amber-50 w-10 h-10 flex items-center justify-center rounded-md text-2xl mr-4 cursor-pointer'
            }
            onClick={() => setShowModal(false)}
          />
        </div>

        <CarsTable cars={customer?.cars} />

        {/*footer*/}
        <button
          type={'button'}
          onClick={() => setShowModal(false)}
          className={
            'block mr-auto ml-0 bg-blue rounded-md text-white font-semibold py-4 px-6 mt-12'
          }
        >
          بستن
        </button>
      </div>
    </Modal>
  )
}

export default CustomerCarsModal
